export default "__VITE_ASSET__BHi5VlN9__"